var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",style:([{ 'background': _vm.params.value}, {'width':'80px'}])},[_c('span',{staticStyle:{}})])
}
var staticRenderFns = []

export { render, staticRenderFns }